import { Component, inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { PackagingDto } from 'src/app/shared/dto/packaging.dto';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonModule } from '@angular/common';
import { PackagingsService } from 'src/app/private/services/packagings.service';

@Component({
    selector: 'app-modal-pallet-list',
    standalone: true,
    imports: [
        NzEmptyModule,
        CommonModule,
    ],
    template: `
        <div class="p-6">
            <h3 class="text-xl font-semibold mb-6">Palets de la orden</h3>
            @if (pallets.length > 0) {
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                @for (pallet of pallets; track pallet.id) {
                <div 
                    (click)="onPalletClick(pallet)"
                    class="bg-orange-400 hover:bg-orange-500 text-white rounded-lg p-4 cursor-pointer transition-all duration-200 hover:shadow-lg flex flex-col justify-between min-h-[140px] min-w-[180px]">
                    <div class="text-center">
                        <div class="font-bold text-sm mb-2 uppercase">{{ pallet.packagingType?.name ?? 'PALET' }}</div>
                        <div class="text-base font-semibold opacity-95 mb-1">
                            Lote: {{ pallet.batchNumber ?? pallet.externalBatchNumber ?? '-' }}
                        </div>
                        <div class="text-2xl font-bold mt-2">
                            {{ pallet.quantity ?? 0 }} 
                            <span class="text-sm font-normal">{{ pallet.packagingType?.measurementUnit?.abbreviation ?? 'UDS' }}</span>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class="text-center text-sm text-gray-500 mt-4 italic">
                Pulsar para imprimir
            </div>
            } @else {
            <nz-empty nzNotFoundContent="No se encontraron palets"></nz-empty>
            }

            <div class="flex justify-end mt-6">
                <button (click)="close()"
                    class="text-white bg-gray-500 hover:bg-gray-600 font-semibold rounded-md text-sm px-6 py-2">
                    Cerrar
                </button>
            </div>
        </div>
    `,
    styles: [`
        :host {
            display: block;
        }
    `]
})
export class ModalPalletListComponent implements OnInit {
    pallets: PackagingDto[] = [];
    processId: number = 0;
    printing: boolean = false;

    private readonly data = inject(NZ_MODAL_DATA);
    private readonly modalRef = inject(NzModalRef);
    private readonly toast = inject(NzMessageService);
    private readonly packagingsService = inject(PackagingsService);

    ngOnInit(): void {
        this.pallets = this.data?.pallets ?? [];
        this.processId = this.data?.processId ?? 0;
    }

    async onPalletClick(pallet: PackagingDto): Promise<void> {
        if (this.printing) return;
        if (!pallet.id) {
            this.toast.warning('El palet no tiene un id válido');
            return;
        }
        if (!this.processId) {
            this.toast.error('No se ha encontrado el proceso de la orden');
            return;
        }

        try {
            this.printing = true;
            this.toast.info('Enviando etiqueta a imprimir...');
            await this.packagingsService.printPalletLabels(this.processId, [pallet.id]);
            this.toast.success('Etiqueta enviada a imprimir correctamente');
        } catch (error: any) {
            this.toast.error(error.message || 'Error al imprimir la etiqueta del palet');
        } finally {
            this.printing = false;
        }
    }

    close(): void {
        this.modalRef.close();
    }
}
